import { render, staticRenderFns } from "./personalEnrichment.vue?vue&type=template&id=5b4350eb&scoped=true"
import script from "./personalEnrichment.vue?vue&type=script&lang=js"
export * from "./personalEnrichment.vue?vue&type=script&lang=js"
import style0 from "./personalEnrichment.vue?vue&type=style&index=0&id=5b4350eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4350eb",
  null
  
)

export default component.exports